export default "__VITE_ASSET__BECQOmZg__"